import React, { useState } from "react";
import "./LocationManagement.css";
import { useNavigate } from "react-router-dom";
import api from "./axiosConfig";

function LocationManagement() {
    const navigate = useNavigate();
    const token = localStorage.getItem("accessToken");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); 

    const [data, setData] = useState({
        id: "", 
        location: "",
        coordinates: [
            [0, 0], // Top-left
            [0, 0], // Top-right
            [0, 0], // Bottom-right
            [0, 0], // Bottom-left
        ],
        working_duration: 0,
        overtime_pay: 0,
    });

    const submitData = async () => {
        try {
            await api.post(
              "/location",
              data,
              { headers: { Authorization: token } }
            );
            setMessage("Location added successfully.");
            setMessageType("success");
            resetForm();
        } catch (err) {
            setMessage(err.response?.data?.error || "Failed to add location.");
            setMessageType("error");
        }
    };

    const resetForm = () => {
        setData({
            id: "", 
            location: "",
            coordinates: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
            ],
            working_duration: 0,
            overtime_pay: 0,
        });
    };

    const handleCoordinateChange = (index, field, value) => {
        const updatedCoordinates = [...data.coordinates];
        updatedCoordinates[index][field] = parseFloat(value) || 0;
        setData({ ...data, coordinates: updatedCoordinates });
    };

    const handleLogout = () => {
        localStorage.removeItem("accessToken");
        navigate("/login");
    };

    const handleBack = () => {
        navigate("/admin");
    };

    return (
        <div className="location-management-container">
            <button className="back-button" onClick={handleBack}>
                Back
            </button>
            <div className="header-title">
                <h1>Location Management</h1>
            </div>

            <button onClick={handleLogout} className="logout-button">
                Logout
            </button>

            <div className="form-wrapper">
                <div className="form-group">
                    <label htmlFor="location">Location Name<span className="required">*</span></label>
                    <input
                        type="text"
                        id="location"
                        placeholder="Enter location name"
                        value={data.location}
                        onChange={(e) => setData({...data, location: e.target.value})}
                        className="form-input"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="working_duration">Working Duration (hours)</label>
                    <input
                        type="numbers"
                        id="working_duration"
                        placeholder="Enter working duration"
                        value={data.working_duration}
                        onChange={(e) => setData({...data, working_duration: parseFloat(e.target.value) || 0})}
                        className="form-input"
                    />
                </div>

                <div className="coordinate-container">
                    {["Top-left", "Top-right", "Bottom-right", "Bottom-left"].map((label, index) => (
                        <div key={index} className={`form-group ${index < 2 ? "top-row" : "bottom-row"}`}>
                            <label>{label} Coordinates</label>
                            <div className="coordinate-wrapper">
                                <label className="coordinate-label">Lat:</label>
                                <input
                                    type="numbers"
                                    placeholder="Latitude"
                                    value={data.coordinates[index]?.[0] || 0}
                                    onChange={(e) => handleCoordinateChange(index, 0, e.target.value)}
                                    className="coordinate-input"
                                />
                                <label className="coordinate-label">Long:</label>
                                <input
                                    type="numberss"
                                    placeholder="Longitude"
                                    value={data.coordinates[index]?.[1] || 0}
                                    onChange={(e) => handleCoordinateChange(index, 1, e.target.value)}
                                    className="coordinate-input"
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <div className="form-group">
                    <label htmlFor="overtime_pay">Overtime Pay</label>
                    <input
                        type="numberss"
                        id="overtime_pay"
                        placeholder="Enter overtime pay"
                        value={data.overtime_pay}
                        onChange={(e) => setData({...data, overtime_pay: parseFloat(e.target.value) || 0})}
                        className="form-input"
                    />
                </div>

                <button onClick={submitData} className="create-button">
                    Add Location
                </button>

                {message && (
                    <p className={`message ${messageType === "error" ? "error" : "success"}`}>
                        {message}
                    </p>
                )}
            </div>
        </div>
    );
}

export default LocationManagement;